import request from '@/utils/request'

const tradeClientApi = {
  trade_project_list: '/trade/project/',
  trade_project_create: '/trade/project/',
  trade_project_update: '/trade/project/',
  trade_project_delete: '/trade/project/',
  trade_project_detail: '/trade/project_detail/',
  trade_project_report_form: '/trade/project/report_form/',
  trade_project_attachment: '/trade/project_attachment/'
}

/**
 * 列表
 */
export function project_list (parameter) {
  return request({
    url: tradeClientApi.trade_project_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function project_create (parameter) {
  return request({
    url: tradeClientApi.trade_project_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function project_update (parameter, project_id) {
  return request({
    url: tradeClientApi.trade_project_update + project_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function project_delete (project_id) {
  return request({
    url: tradeClientApi.trade_project_delete + project_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function project_detail (parameter) {
  return request({
    url: tradeClientApi.trade_project_detail,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter,
    timeout: 60000
  })
}

export function trade_project_report_form (parameter) {
  return request({
    url: tradeClientApi.trade_project_report_form,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter,
    timeout: 60000
  })
}

/**
 * 列表
 */
export function project_attachment_list (parameter) {
  return request({
    url: tradeClientApi.trade_project_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

export function project_attachment_create (parameter) {
  return request({
    url: tradeClientApi.trade_project_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function project_attachment_delete (project_id) {
  return request({
    url: tradeClientApi.trade_project_attachment + project_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
